var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},_vm.$listeners),[_c('path',{attrs:{"fill":"#c0ae66","d":"M16.496 0a.75.75 0 00-.516.227l-9.97 9.97-3.97-3.97a.75.75 0 10-1.06 1.06l4.5 4.5a.75.75 0 001.06 0l10.5-10.5A.75.75 0 0016.496 0z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }